import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ImportantDatesHeader from './components/ImportantDatesHeader';
import DatesTimeline from './components/DatesTimeline';

const ImportantDatesPage = () => {
  return (
    <>
      <title>Önemli Tarihler | İstanbul Dental Kongresi 2026</title>
      <meta name="description" content="İstanbul Dental Kongresi 2026 önemli tarihler ve son başvuru tarihleri. Erken kayıt son tarihi, abstract gönderim tarihi ve kongre tarihleri. 2-3 Mayıs 2026." />
      <meta name="keywords" content="istanbul dental kongresi tarihler, dental kongre 2026 son başvuru, kongre önemli tarihler" />
      <link rel="canonical" href="https://ankaradentalkongresi.com/onemli-tarihler" />
      <meta property="og:title" content="Önemli Tarihler | İstanbul Dental Kongresi 2026" />
      <meta property="og:description" content="Erken kayıt son tarihi, abstract gönderim ve kongre tarihleri. İstanbul Dental Kongresi 2026." />
      <meta property="og:url" content="https://ankaradentalkongresi.com/onemli-tarihler" />
      <div className="min-h-screen bg-white">
        <Navbar />
        <ImportantDatesHeader />
        <DatesTimeline />
        <Footer />
      </div>
    </>
  );
};

export default ImportantDatesPage;
